import React, { useState } from 'react';

import { ContactLink } from './Contact.styled';
import { CommentSmile } from 'assets/icons/Icons';
import { Text } from 'components/v2/Typography/Text';
import { theme } from 'kb-shared';
import { useBreakpoints } from 'utilities/useBreakpoints';

import { FeedbackModal } from './FeedbackModal';

type Size = 'sm' | 'md';

type Props = {
  textSize: Size;
  iconStyle?: React.CSSProperties;
};

export const Feedback: React.FC<Props> = ({ textSize }) => {
  const [openedGiveUsFeedback, setOpenedGiveUsFeedback] = useState<boolean>(false);
  const { isMobile } = useBreakpoints();

  return (
    <>
      <Text size={textSize}>
        <ContactLink
          onClick={() => setOpenedGiveUsFeedback(true)}
          $iconColor={theme.colors.neutral.primaryNavy}
          $linkColor={theme.colors.neutral.primaryNavy}
        >
          <CommentSmile />
          <strong>Give us Feedback!</strong>
        </ContactLink>
      </Text>
      <FeedbackModal
        id="116"
        open={openedGiveUsFeedback}
        title="Give us Feedback"
        close={() => setOpenedGiveUsFeedback(false)}
        mobileHeight={isMobile ? '80vh' : undefined}
      />
    </>
  );
};
